var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('Notification',{attrs:{"content":_vm.notificationContent,"type":_vm.notificationStatus,"isNotificationOpen":_vm.isNotificationOpen},on:{"notificationClosed":_vm.closeNotification}}),_c('DatLayout',[_c('DatTypeContainer',{attrs:{"slot":"dat-type-container"},slot:"dat-type-container"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }